module.exports = __webpack_public_path__ + "static/media/4.16d8e12e.jpg";